


























































































































import Vue from 'vue'
import StarRating from 'vue-star-rating'
import { Asset, AssetType, VideoAsset, InstagramAsset, TweetAsset} from '@/types/assets'
import moment from 'moment'
import './AssetDetails.scss'
import SocialDetails from './SocialDetails/SocialDetails.vue'
import TwitterPollDetails from '@/components/AssetDetails/TwitterPollDetails/TwitterPollDetails.vue'

export default Vue.extend({
  name: 'AssetDetails',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    assetId: {
      type: String,
      required: true
    },
    previousAssetId: {
      type: String,
      required: false
    },
    nextAssetId: {
      type: String,
      required: false
    },
    folderId: {
      type: String,
      required: false,
      default: null
    }
  },
  mounted () {
    if (this.$refs.hasOwnProperty('videoelement')) {
      const videlement = this.$refs.videoelement as HTMLVideoElement
      videlement.volume = this.assetVolume
    }

    // using timeout to make sure element is focusable
    setTimeout(() => {
      if (this.$refs.hasOwnProperty('assetwrapper')) {
        const div = this.$refs.assetwrapper as HTMLDivElement | undefined
        if (div) {
          div.focus()
        }
        this.focused = true // avoid focusing away from your text fields etc

        if (this.$refs.videoelement) {
          const videlement = this.$refs.videoelement as HTMLVideoElement
          videlement.volume = this.assetVolume
        }
      }
    }, 250)
  },
  data: () => ({
    mode: '',
    focused: false,
    volumeTimeout: null as null|NodeJS.Timeout
  }),
  methods: {
    close () {
      this.$emit('close')
    },
    openPrevious () {
      if (!this.previousAssetId) {
        return
      }
      this.$emit('previous')
    },
    openNext () {
      if (!this.nextAssetId) {
        return
      }
      this.$emit('next')
    },
    setRating (rating) {
      this.$store.direct.dispatch.assets.updateAssetStars({ id: this.assetId, stars: rating})
    },
    formatDate (date) {
      return moment.unix(date / 1000).format('M/D/YYYY h:mm a')
    },
    volumeChange (event) {
      if (this.volumeTimeout !== null) {
        clearTimeout(this.volumeTimeout)
      }
      if (!event.srcElement) {
        return
      }
      this.volumeTimeout = setTimeout(() => {
        const videoElement: HTMLVideoElement|undefined = event.srcElement
        if (videoElement === undefined) return
        const asset = Object.assign({}, this.asset)
        const volume = videoElement.muted ? 0 : videoElement.volume * 100
        if (asset.type === AssetType.Video) {
          if (Math.abs(volume / 100 - this.assetVolume) > 0.01) {
            this.$store.direct.dispatch.assets.updateAssetVolume({ id: this.assetId, volume: volume})
          }
          this.volumeTimeout = null
        }
      }, 1000)
    },
    assetChanged (asset: InstagramAsset|TweetAsset): void {
      this.$store.direct.dispatch.assets.updateAsset(asset)
    }
  },
  watch: {
    asset () {
      const previewVideo = this.$refs.previewVideo as HTMLVideoElement|undefined
      if (previewVideo) previewVideo.load()
    }
  },
  computed: {
    assetVolume (): number {
      if (!this.asset) {
        return 0
      }
      let volume = 1
      if (this.asset.hasOwnProperty('volume')) {
        const vidasset = this.asset as VideoAsset
        if (vidasset.volume) {
          volume = vidasset.volume
        }
      }
      return volume / 100
    },
    asset (): undefined|Asset {
      if (!this.folderId) return

      const assetGroup = this.$store.direct.state.assets.assetGroupAssets[this.folderId]
      if (assetGroup) return assetGroup[this.assetId]

      return this.$store.direct.state.assets.sceneAssets[this.assetId]
    },
    assetType (): AssetType {
      if (this.asset) {
        return this.asset.type
      }
      return AssetType.Unknown
    }
  },
  components: {
    SocialDetails,
    StarRating,
    TwitterPollDetails,
  }
})
